module.exports = __webpack_public_path__ + "img/priority.082f884f.svg";